import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TravellerActions } from './actions/traveller.actions';
import { TravellerItemComponent } from './components/traveller-item/traveller-item.component';
import { TravellerService } from './traveller.service';
import { CoreModule } from '@ridango/core';

@NgModule( {
    imports: [
        CommonModule,
        CoreModule
    ],
    declarations: [ TravellerItemComponent ],
    providers: [ TravellerService, TravellerActions ],
    exports: [ TravellerItemComponent ]
} )
export class TravellerModule { }
